import React, { useCallback } from "react"
import { useHistory } from "react-router-dom"
import classnames from "classnames"
import { toast } from "react-toastify"

import styles from "./index.module.scss"
import FreelancerCard from "../../../components/cards/FreelancerCard"
import ToastInfo from "../../../components/ToastContents/ToastInfo"
import services from "../../../services"
import { paths } from "../../../routes/paths"

const Freelancers = ({ data, removeFromFavorites }) => {
    const history = useHistory()

    const handleFavoriteToggle = useCallback(
        async (profileKey, shouldFavorite, freelancerData) => {
            try {
                // Send profile_key as uuid - backend stores this as external_id
                await services.favoriteServices.addRemoveToList({
                    type: "freelancer",
                    uuid: profileKey,
                    favorite: shouldFavorite,
                    freelancerData: shouldFavorite ? freelancerData : undefined,
                })
                if (shouldFavorite) {
                    toast.info(
                        <ToastInfo>
                            Freelancer was successfully added to your Favorites
                        </ToastInfo>,
                        { position: toast.POSITION.TOP_RIGHT }
                    )
                } else {
                    // Remove from the local list when unfavorited
                    removeFromFavorites(profileKey)
                }
            } catch (error) {
                console.error("Failed to toggle freelancer favorite:", error)
                throw error
            }
        },
        [removeFromFavorites]
    )

    return (
        <div className={classnames(styles.listWrap, styles.opportunityList)}>
            {data.map((item) => (
                <FreelancerCard
                    key={item.uuid}
                    freelancerAvatar={item.photo}
                    freelancerName={item.name}
                    freelancerUuid={item.external_id}
                    profileKey={item.external_id}
                    chatUuid={item.chat || ""}
                    description={item.description}
                    isOwned={false}
                    onClick={() =>
                        history.push(
                            paths.selectedFreelancerProfile(item.external_id),
                            { profile: item }
                        )
                    }
                    isHaveChatButton={false}
                    isFavorite={true}
                    onFavoriteToggle={handleFavoriteToggle}
                    dbUuid={item.uuid}
                    skills={item.title}
                    classes={styles.cardWrapper}
                />
            ))}
        </div>
    )
}

export default Freelancers
